import i18n from "i18next";
import { initReactI18next } from "react-i18next";

// Import Russian translation
import footerRU from "./locales/ru/footer.json";
import navbarRU from "./locales/ru/navbar.json";
import homeRU from "./locales/ru/home.json";
import servicesRU from "./locales/ru/services.json";
import libraryRU from "./locales/ru/library.json";
import contactRU from "./locales/ru/contact.json";
import careerRU from "./locales/ru/career.json";
import aboutRU from "./locales/ru/about.json";
import productsRU from "./locales/ru/products.json";
import casesRU from "./locales/ru/cases.json";
import researchRU from "./locales/ru/research.json";
import certificatesRU from "./locales/ru/certificates.json";
import teamRu from "./locales/ru/team.json";
import not_foundRU from "./locales/ru/not_found.json";
import safetyRU from "./locales/ru/safety.json";


// Import English translations
import footerEN from "./locales/en/footer.json";
import navbarEN from "./locales/en/navbar.json";
import homeEN from "./locales/en/home.json";
import servicesEN from "./locales/en/services.json";
import libraryEN from "./locales/en/library.json";
import contactEN from "./locales/en/contact.json";
import careerEN from "./locales/en/career.json";
import aboutEN from "./locales/en/about.json";
import productsEN from "./locales/en/products.json";
import casesEN from "./locales/en/cases.json";
import researchEN from "./locales/en/research.json";
import certificatesEN from "./locales/en/certificates.json";
import teamEN from "./locales/en/team.json";
import not_foundEN from "./locales/en/not_found.json";
import safetyEN from "./locales/en/safety.json";


const resources = {

    en: {
        footer: footerEN,
        navbar: navbarEN,
        home: homeEN,
        services: servicesEN,
        library: libraryEN,
        contact: contactEN,
        career: careerEN,
        about: aboutEN,
        products: productsEN,
        cases: casesEN,
        research: researchEN,
        certificates: certificatesEN,
        team: teamEN,
        not_found: not_foundEN,
        safety: safetyEN,
    },


    ru: {
        footer: footerRU,
        navbar: navbarRU,
        home: homeRU,
        services: servicesRU,
        library: libraryRU,
        contact: contactRU,
        career: careerRU,
        about: aboutRU,
        products: productsRU,
        cases: casesRU,
        research: researchRU,
        certificates: certificatesRU,
        team: teamRu,
        not_found: not_foundRU,
        safety: safetyRU,
    },
};
const lang = localStorage.getItem('lang');
i18n
    .use(initReactI18next)
    .init({
        resources,
        lng: lang || "ru", // Default language is Russian or Set your Desire default language
        fallbackLng: "en", // Fallback language if translation is missing
        interpolation: { escapeValue: false },
    });

export default i18n;
